/*** IMPORTS FROM imports-loader ***/
var define = false;

require('../modules/web.timers');
require('../modules/web.immediate');
require('../modules/web.dom.iterable');
module.exports = require('../modules/_core');

